import { Helmet } from 'react-helmet-async';
import Biomarkers from '../components/Biomarkers/Biomarkers';

export default function BiomarkersPage() {
  return (
    <>
      <Helmet>
        <title>DISGENET: Biomarkers</title>
        <meta name="description" content="Explore biomarkers in DISGENET." />
      </Helmet>
      <Biomarkers />
    </>
  );
}
